import { CALL_API } from "admin/middlewares/api";

export const USER_PORTFOLIO_SELL_REQUEST = "USER_PORTFOLIO_SELL_REQUEST";
export const USER_PORTFOLIO_SELL_SUCCESS = "USER_PORTFOLIO_SELL_SUCCESS";
export const USER_PORTFOLIO_SELL_ERROR = "USER_PORTFOLIO_SELL_ERROR";

export function user_portfolio_sell(CreditId, DepotId, SalesFee) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/shares/sellorder",
      method: "POST",
      authenticatedRequest: true,
      data: {
        CreditId,
        DepotId,
        SalesFee,
      },
      additionalData: CreditId,
      types: [
        USER_PORTFOLIO_SELL_REQUEST,
        USER_PORTFOLIO_SELL_SUCCESS,
        USER_PORTFOLIO_SELL_ERROR,
      ],
    },
  };
}
